// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"1362d17d","309":"e38aa196","541":"fe36494f","632":"5f36af07","742":"e7475497","793":"51679b6a"}[chunkId] + ".chunk.js";
};